import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

// SwiperCore.use([Navigation, Pagination]);

export default function SectionI() {
    const { t } = useLang('powerstream.detail.sectionI');
    const swiperData = [
        { title: t('card1_title'), desc: t('card1_desc') },
        { title: t('card2_title'), desc: t('card2_desc') },
        { title: t('card3_title'), desc: t('card3_desc') },
    ];

    return (
        <div className={styles.recognised}>
            <div className="i-section">
                <p className="title">{t('title')}</p>
                <div className="i-swiper">
                    <Swiper
                        // navigation={true}
                        // pagination={{
                        //     clickable: true,
                        // }}
                        spaceBetween={20}
                        slidesPerView={3}
                        // grabCursor
                        className="endorsed-swiper"
                        noSwiping={false}
                    >
                        {swiperData.map((item: any, index) => (
                            <SwiperSlide key={index} className="swiper-item">
                                <div className="item-box">
                                    <p className="item-title">{item.title}</p>
                                    <span className="item-svg"></span>
                                    <p className="item-desc">{item.desc}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
